import HomeTemplate, { HomeTemplateV2 } from "../components/HomeTemplate";

import AboutOrbit from "../view/About";
import HomeOrbit from "../view/HomeOrbit";
import ServicesOrbit from "../view/ServicesOrbit";
import BlockChainTec from "../view/ServicesOrbit/BlockChainTec";
import HowItWorks from "../view/HowItWorks";
import Contact from "../view/ContactUs"

const routeHomeTemplate = [
  {
    Component: HomeOrbit,
    exact: true,
    path: "/",
  },
  {
    Component: AboutOrbit,
    exact: true,
    path: "/about",
  },

  // {
  //   Component: ServicesOrbit,
  //   exact: true,
  //   path: "/services",
  // },
];

const routeHomeTemplateV2 = [
  {
    Component: ServicesOrbit,
    exact: true,
    path: "/services/web&dev",
  },

  {
    Component: BlockChainTec,
    exact: true,
    path: "/services/blockchain-tecnology",
  },

  {
    Component: HowItWorks,
    exact: true,
    path: "/how-it-works",
  },

  {
    Component: Contact,
    exact: true,
    path: "/contact-us",
  },
];

export const renderRouteHome = () => {
  return routeHomeTemplate.map((_route, index) => {
    return (
      <>
        <HomeTemplate key={`route-${index}`} exact={_route.exact} Component={_route.Component} path={_route.path} />
      </>
    );
  });
};

export const renderRouteHomeV2 = () => {
  return routeHomeTemplateV2.map((_route, index) => {
    return (
      <>
        <HomeTemplateV2 key={`route-${index}`} exact={_route.exact} Component={_route.Component} path={_route.path} />
      </>
    );
  });
};
